// feedConstants.js
'use strict';

export const OPTION_UNSET = 'unset';

export const QueryType = {
  FILTER: 'filter',
  SORT: 'sort',
};
export const QueryPrefix = {
  [QueryType.FILTER]: 'FILTERS',
  [QueryType.SORT]: 'SORTINGS',
};

export const QUERY_STRING_KEY = '_q';
export const QUERY_SEPARATOR = ',';
export const SUPPORTED_FEED_QUERIES = [
  'sorting',
  'filters',
  'filters_v2',
  'ui',
  'ssr',
];
export const SANITIZE_FEED_QUERIES = ['sorting', 'filters', 'filters_v2']; // related to the selectPath setting and getting feed in the store

export const FeedNameType = {
  USERS: 'users',
  HASHTAGS: 'hashtags',
  CATEGORIES: 'categories',
  MESSAGES: 'messages',
};

export const CategoryLayout = {
  GRID: 'grid',
  LIST: 'list',
  ROW: 'row',
};

export const CategoryComponentUi = {
  OUTBOX_MESSAGE: 'OutboxMessage',
  PROFILE_CARD_ITEM: 'ProfileCardItem',
  MESSAGE_CARD: 'MessageCard',
  FLIX_LIST_ITEM: 'FlixListItem',
};

export const HomeCategoryUi = {
  FLIX: 'flix',
  FLIX_GRID: 'flix-grid',
  /**
   * Use grid layout on non-mobile device, and use list layout on mobile device.
   */
  FLIX_GRID_MOBILE_FLIX_LIST: 'flix-grid-mobile-flix-list',
  FLIX_LIST: 'flix-list',
  LIVESTREAM: 'livestream',
  LIVESTREAM_GRID: 'livestream-grid',
  LIVESTREAM_SQUARE: 'livestream-square',
  LIVESTREAM_TOP: 'livestream-top',
  SHORTS: 'shorts',
  SHORTS_METADATA_CARD: 'shorts-metadata-card',
  SHORTS_METADATA_CARD_GRID: 'shorts-metadata-card-grid',
  STORY: 'story',
  STORY_LIST: 'story-list',
  STORY_METADATA_CARD: 'story-metadata-card',
  STORY_METADATA_CARD_GRID: 'story-metadata-card-grid',
  STORY_GRID: 'story-grid',
  USER: 'user',
  USER_GRID: 'user-grid',
  USER_SQUARE: 'user-square',
  USER_SQUARE_DOUBLE_ROW: 'user-square-double-row',
  USER_SQUARE_GRID: 'user-square-grid',
  LEADERBOARD_USER_SQUARE: 'leaderboard-user-square',
  LEADERBOARD_USER_SQUARE_DOUBLE_ROW: 'leaderboard-user-square-double-row',
  LEADERBOARD_USER_SQUARE_GRID: 'leaderboard-user-square-grid',
  POST_FEED: 'post-feed',
  POST_CARD_GRID: 'post-card-grid',
  MESSAGE_LIST: 'message-list',
};

export const UiQueryWhiteList = Object.fromEntries(
  Object.entries(HomeCategoryUi).map(([key, value]) => [value, key])
);

export const PSEUDO_TRENDING_HASHTAG = 'pseudo_trending_hashtag';
export const PSEUDO_TRENDING_CATEGORY = 'pseudo_trending_category';
export const PSEUDO_LEADERBOARD = 'pseudo_leaderboard';
export const PSEUDO_SHOWCASE = 'pseudo_showcase';
